'use client';
import Image from 'next/image';
import React from 'react';

const PartnersCollaborators = () => {
  const logos = [
    {
                  href: "https://www.globalaishow.com/",
                  src: "/images/gais.webp",
                  alt: "gais",
                },
                {
                  href: "https://www.globalblockchainshow.com/",
                  src: "/images/gbs.webp",
                  alt: "gbs",
                },
                {
                  href: "https://www.coriniumintelligence.com/",
                  src: "/images/corinium-logo-new.webp",
                  alt: "Corinium",
                },
                {
                  href: "https://www.re-work.co/",
                  src: "/images/rework-logo.svg",
                  alt: "rework",
                },
                {
                  href: "https://seablockchainweek.org/",
                  src: "/images/southeast-asia.webp",
                  alt: "SoutheastAsia",
                },
                
  ];

  return (
    <section data-component-id="src/app/PartnersCollaborators.jsx:36:4" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="36" data-component-end-line="68" data-component-file="PartnersCollaborators.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20bg-%5Blinear-gradient(318deg%2C%2300000000_60%25%2C%231d3819_100%25)%5D%20py-%5B40px%5D%20sm%3Apy-%5B60px%5D%20md%3Apy-%5B80px%5D%20px-4%20sm%3Apx-6%20md%3Apx-10%22%7D"
      id="partners"
      className="w-full bg-[linear-gradient(318deg,#00000000_60%,#1d3819_100%)] py-[40px] sm:py-[60px] md:py-[80px] px-4 sm:px-6 md:px-10"
    >
      <div data-component-id="src/app/PartnersCollaborators.jsx:40:6" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="40" data-component-end-line="67" data-component-file="PartnersCollaborators.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1240px%5D%20mx-auto%20flex%20flex-col%20items-center%20gap-%5B20px%5D%20sm%3Agap-%5B30px%5D%20md%3Agap-%5B40px%5D%20px-3%22%7D" className="max-w-[1240px] mx-auto flex flex-col items-center gap-[20px] sm:gap-[30px] md:gap-[40px] px-3">
        {/* Main Heading */}
        <h2 data-component-id="src/app/PartnersCollaborators.jsx:42:8" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="42" data-component-end-line="44" data-component-file="PartnersCollaborators.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-center%20text-%5B24px%5D%20sm%3Atext-%5B28px%5D%20lg%3Atext-%5B32px%5D%20font-semibold%20mb-8%20bg-%5Blinear-gradient(1deg%2C%2317c64f_0%25%2C%2310b981_50%25%2C%23005529_100%25)%5D%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Past%20Media%20Partners%22%7D" className="text-center text-[24px] sm:text-[28px] lg:text-[32px] font-semibold mb-8 bg-[linear-gradient(1deg,#17c64f_0%,#10b981_50%,#005529_100%)] bg-clip-text text-transparent">
          Past Media Partners
        </h2>

        {/* Logos Grid */}
        <div data-component-id="src/app/PartnersCollaborators.jsx:47:8" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="47" data-component-end-line="66" data-component-file="PartnersCollaborators.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-4%20lg%3Agrid-cols-5%20gap-4%20sm%3Agap-5%20md%3Agap-6%20w-full%22%7D" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-5 md:gap-6 w-full">
          {logos.map((logo, idx) => (
            <a data-component-id="src/app/PartnersCollaborators.jsx:49:12" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="49" data-component-end-line="64" data-component-file="PartnersCollaborators.jsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22block%20w-full%20h-%5B90px%5D%20sm%3Ah-%5B150px%5D%20md%3Ah-%5B100px%5D%20bg-white%20rounded-%5B10px%5D%20overflow-hidden%20flex%20items-center%20justify-center%20shadow-md%20p-4%22%7D"
              key={idx}
              href={logo.href || logo.link} // ✅ Supports both "href" and "link"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="block w-full h-[90px] sm:h-[150px] md:h-[100px] bg-white rounded-[10px] overflow-hidden flex items-center justify-center shadow-md p-4"
            >
              <Image data-component-id="src/app/PartnersCollaborators.jsx:56:14" data-component-path="src/app/PartnersCollaborators.jsx" data-component-line="56" data-component-end-line="63" data-component-file="PartnersCollaborators.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-%5B180px%5D%20h-%5B60px%5D%20object-contain%22%7D"
                src={logo.src}
                alt={logo.alt}
                width={200}
                height={80}
                unoptimized
                className="w-[180px] h-[60px] object-contain"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersCollaborators;
